<div class="flex flex-col">
  <select class={{selectClass}} (change)="onSelectChange($event)">
    <option value="" disabled>Selecciona una opción</option>
    <option *ngFor="let opt of options" [value]="opt.value" [selected]="(opt.value == selectedValue)">{{ opt.label }}</option>
  </select>
</div>